import { render, staticRenderFns } from "./OrderStateHistoryItem.vue?vue&type=template&id=717e6372&scoped=true&"
import script from "./OrderStateHistoryItem.vue?vue&type=script&lang=js&"
export * from "./OrderStateHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderStateHistoryItem.vue?vue&type=style&index=0&id=717e6372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e6372",
  null
  
)

export default component.exports